export const filterConfig = {
    comprehensive_filters: [
        {
            heading: "Severity",
            type: "multiple",
            column: "severity",
            options: [
                { label: "Critical", value: "Critical" },
                { label: "High", value: "High" },
                { label: "Medium", value: "Medium" },
                { label: "Low", value: "Low" },
            ],
        },
        {
            heading: "Exploitation Status",
            type: "multiple",
            column: "exploitationStatus",
            options: [
                { label: "Active", value: "Active" },
                { label: "None", value: "None" },
                { label: "Proof of concept", value: "Poc" },
            ],
        },
        {
            heading: "CISA KEV",
            type: "single",
            column: "cisaKEV",
            options: [
                { label: "True", value: ["true"] },
                { label: "False", value: ["false"] },
            ],
        },
        {
            heading: "Zero Day",
            type: "single",
            column: "zeroDay",
            options: [
                { label: "True", value: ["true"] },
                { label: "False", value: ["false"] },
            ],
        },
        {
            heading: "Patch Availability",
            type: "single",
            column: "patchAvailability",
            options: [
                { label: "True", value: ["true"] },
                { label: "False", value: ["false"] },
            ],
        }
    ]
}